import React, { Component } from 'react'
import { connect } from 'react-redux'
import _ from 'underscore'
import { injectIntl, FormattedMessage } from 'react-intl'
import { sendTrackingData } from '@vmockinc/dashboard/services/tracking'
import InfoScreens from '../InfoScreens'
import {
  feedbackContentProfilePicture,
  feedbackMap,
} from '../Constants/DetailedFeedbackText'
import {
  profilePictureFeedbackAriaLabel,
  infoScreenConnectLabel,
} from '../Constants/AriaLabelText'
import { InfoComponent } from '../HelperComponent/FeedbackBlock'
import { sectionActionableContent } from '../Constants/DetailedFeedbackText'
import { northwesternCustom } from '../Constants/CommunityCustomisationText'
import { fetchCustomisation } from '../../services/helpers'
import {
  showEditModal,
  changeProfilePicInitialEditState,
} from '../../actions/Edit'

const colorMap = {
  green: 'color-green',
  yellow: 'color-orange',
  red: 'color-red',
  gray: 'color-gray',
}

const symbolMap = {
  green: <span className="fa fa-check" aria-hidden="true" />,
  yellow: <span className="fa fa-exclamation" aria-hidden="true" />,
  red: <span className="fa fa-times" aria-hidden="true" />,
}

const iconMap = {
  green: 'icon-good-job.svg',
  yellow: 'icon-on-track.svg',
  red: 'icon-needs-work.svg',
}

const sectionOrder = [
  'profile_picture',
  'personal_information',
  'headline',
  'summary',
  'experience',
  'education',
]

class Overall extends Component {
  constructor(props) {
    super(props)
    this.state = {
      showInfoScreen: false,
      activeInfoScreen: '',
    }
    this.textMap = {
      green: props.intl.formatMessage({ id: "aspire.overall.goodJob", defaultMessage: "Good Job!" }),
      yellow: props.intl.formatMessage({ id: "aspire.overall.onTrack", defaultMessage: "On Track!" }),
      red: props.intl.formatMessage({ id: "aspire.overall.needsWork", defaultMessage: "Needs Work!" }),
    }
    this.beSectionToSectionMap = {
      profile_picture: 'Profile Picture',
      personal_information: 'Personal Information',
      headline: 'Headline',
      summary: 'Summary',
      education: 'Education',
      experience: 'Experience',
    }

  }

  renderTop(scores) {
    const { tabIndex, intl } = this.props

    let overallColor = scores['Total']['class']
    return (
      <>
        <div className="feedback-panel-top-bar">
          <div
            className="top-bar-section-name"
            role="heading"
            aria-level="3"
          >
            <FormattedMessage id="aspire.overall.overallProfileFeedback" defaultMessage="Overall Profile Feedback" />
          </div>
          <div className="top-bar-divider" />
          <div
            className={'top-bar-status text-' + overallColor}
            tabIndex={tabIndex}
          >
            {this.textMap[overallColor]}
          </div>
        </div>
        <div className="feedback-panel-info-div">
          <div className="feedback-panel-info-text">
            <p>
              <FormattedMessage id="aspire.overall.clickSectionToReview" defaultMessage="Click on a section to review detailed feedback" />
            </p>
          </div>
        </div>
      </>
    )
    return null
  }

  renderSectionFeedbackSummary(scores) {
    const { feedback, user, isUKEnable, intl } = this.props

    const { section_wise_actionable_content } = feedback
    let sectionActionableContentText = sectionActionableContent(intl, isUKEnable, user && user.isResumeCalledCv)
    let sectionDivs = []
    _.mapObject(section_wise_actionable_content, (value, index) => {
      if (index === 'personal_information' && value['tag'] === 'name_resume') {
        value['tag'] = user && user.isResumeCalledCv ? 'name_cv' : value['tag']
      }
      let content = []
      if (value['tag'] === 'green') {
        content = sectionActionableContentText['green']
      } else if (index === 'experience') {
        content = sectionActionableContentText[index][value['tag']]
        if (value['tag'] === 'word_count' || value['tag'] === 'base_case_1') {
          content['heading'] = value['heading']
        }
      } else {
        content = sectionActionableContentText[index][value['tag']]
      }
      let sectionName = this.beSectionToSectionMap[value.section] === 'Summary' 
        ? 'About' 
        : this.beSectionToSectionMap[value.section]
      const sectionIdMap = {
        "Profile Picture": "aspire.logscreenNames.profilePicture",
        "Personal Information": "aspire.logscreenNames.personalInformation",
        "Headline": "aspire.logscreenNames.headline",
        "About": "aspire.logscreenNames.summary",
        "Experience": "aspire.logscreenNames.experience",
        "Education": "aspire.logscreenNames.education"
      };
      const id = sectionIdMap[sectionName] || sectionName;
      sectionName = intl.formatMessage({ id: id, defaultMessage: sectionName });
      let sectionDiv = (
        <div
          className="overall-summary-section-div"
          data-key={this.beSectionToSectionMap[value.section]}
          onClick={(e) =>
            this.props.onSelectSection(e, this.beSectionToSectionMap[value.section])
          }
        >
          <div className="overall-summary-section-desc">
            <div className="overall-summary-section-header">
              <div
                className="overall-summary-section-name"
                aria-label={sectionName}
              >
                {sectionName}
              </div>
              <div className="top-bar-divider" />
              <div
                className={'overall-summary-section-status text-' + value.zone}
              >
                {this.textMap[value.zone]}
              </div>
            </div>
            {value.zone !== 'green' && (
              <div className="overall-summary-section-info">
                <div className="overall-summary-section-icon">
                  <img
                    alt=""
                    src={`${process.env.APP_BASE_URL}dist/images/${
                      iconMap[value.zone]
                    }`}
                    className="feedback-parameter-icon"
                    width="16px"
                    height="16px"
                  />
                </div>
                {content['heading']}
              </div>
            )}
          </div>
          <div className="overall-summary-section-arrow">
            <div class="arrow arrow-right"></div>
          </div>
        </div>
      )
      sectionDivs[value.section] = sectionDiv
    })
    return (
      <div className="feedback-summary" tabIndex="0">
        {sectionOrder.map((value) => sectionDivs[value])}
      </div>
    )
  }

  renderFeedback(parameter, title, feedback) {
    const { tabIndex, isUKEnable, intl } = this.props
    if (_.isUndefined(feedback['color_feedback'])) {
      let content = feedbackMap(intl, isUKEnable)[parameter]['gray']
      let eventKey = feedbackMap(intl, isUKEnable)[parameter]['key']

      let parameterFeedback = (
        <div
          className="feedback-parameter-section"
          tabIndex={tabIndex}
          aria-label={content}
        >
          <div className="feedback-parameter-section-header">
            <div className="feedback-parameter-status-icon"></div>
            <div className="feedback-parameter-section-heading">{title}</div>
          </div>
        </div>
      )

      return [parameterFeedback, 'not_detected']
    } else {
      let content =
        feedbackMap(intl, isUKEnable)[parameter][feedback['color_feedback']]
      let eventKey = feedbackMap(intl, isUKEnable)[parameter]['key']

      let parameterFeedback = (
        <div
          className="feedback-parameter-section"
          tabIndex={tabIndex}
          aria-label={content}
        >
          <div className="feedback-parameter-section-header">
            <div className="feedback-parameter-status-icon">
              <img
                alt=""
                src={`${process.env.APP_BASE_URL}dist/images/${
                  iconMap[feedback['color_feedback']]
                }`}
                className="feedback-parameter-icon"
              />
            </div>
            <div className="feedback-parameter-section-heading">{title}</div>
          </div>
          <div className="feedback-parameter-section-detail">{content}</div>
        </div>
      )

      return [parameterFeedback, 'detected']
    }
  }

  handleTracking(module) {
    let countOfAvailableClick = this.countOfAvailableClick

    let jsonObjectForTracking = {
      eventLabel: 'feedback_panel_nav_profile_picture_click_info',
      currentSection: 'Profile Picture',
      selectedModule: module,
      countOfAvailableClick: countOfAvailableClick,
    }
    this.sendTrackingDataDebounce(
      'event',
      'aspire_detailed_feedback_screen',
      'click',
      JSON.stringify(jsonObjectForTracking)
    )
  }

  fetchScores(summaryData) {
    let mods = {
      Content: {
        index1: 'section_wise_content_score_class',
        index3: 'overall_content_score_class',
        index4: 'overall_content_score',
      },
      Skills: {
        index1: 'section_wise_skills_score_class',
        index3: 'overall_skills_score_class',
        index4: 'overall_skills_score',
      },
      Visibility: {
        index1: 'section_wise_profile_visibility_score_class',
        index3: 'overall_profile_visibility_score_class',
        index4: 'overall_profile_visibility_score',
      },
    }

    let sections = {
      Headline: {
        index2: 'headline',
      },
      Summary: {
        index2: 'summary',
      },
      Experience: {
        index2: 'experience',
      },
      Education: {
        index2: 'education',
      },
      'Volunteer Experience': {
        index2: 'volunteer_experience',
      },
      Skills: {
        index2: 'skills_&_expertise',
      },
      Projects: {
        index2: 'projects',
      },
      Publications: {
        index2: 'publications',
      },
    }

    const crosses = {
      Content: ['Skills'],
      Skills: ['Education', 'Publications'],
      Visibility: [
        'Volunteer Experience',
        'Skills',
        'Projects',
        'Publications',
      ],
    }

    let scores = {
      Total: {
        class: summaryData['overall_total_score_class']['color_feedback'],
        score: summaryData['overall_total_score_class']['overall_score'],
        text: summaryData['overall_total_score_class']['color_feedback']
          .toString()
          .toUpperCase(),
      },
    }

    for (let mod in mods) {
      scores[mod] = {}
      scores[mod]['Total'] = {
        class:
          'progress-bar progress-bar-' +
          summaryData[mods[mod]['index3']]['color_feedback'],
        score: summaryData[mods[mod]['index3']][mods[mod]['index4']],
        color: summaryData[mods[mod]['index3']]['color_feedback'],
      }

      for (let section in sections) {
        if (_.contains(crosses[mod], section)) {
          scores[mod][section] = {
            class: 'cross-circle',
          }
        } else if (
          _.isUndefined(summaryData[mods[mod]['index1']]) ||
          _.isUndefined(
            summaryData[mods[mod]['index1']][sections[section]['index2']]
          ) ||
          _.isUndefined(
            summaryData[mods[mod]['index1']][sections[section]['index2']][
              mods[mod]['index3']
            ]
          ) ||
          _.isUndefined(
            summaryData[mods[mod]['index1']][sections[section]['index2']][
              mods[mod]['index3']
            ][mods[mod]['index4']]
          )
        ) {
          scores[mod][section] = {
            class: 'question-circle',
          }
        } else {
          scores[mod][section] = {
            class:
              'progress-bar progress-bar-' +
              summaryData[mods[mod]['index1']][sections[section]['index2']][
                mods[mod]['index3']
              ]['color_feedback'],
            score:
              summaryData[mods[mod]['index1']][sections[section]['index2']][
                mods[mod]['index3']
              ][mods[mod]['index4']] + 3.0,
            color:
              summaryData[mods[mod]['index1']][sections[section]['index2']][
                mods[mod]['index3']
              ]['color_feedback'],
          }
        }
      }
    }

    return scores
  }

  render() {
    const { currentSection, ui, user, feedback } = this.props
    const { community } = user
    const scores = this.fetchScores(feedback['summary_screen'])
    return (
      <div>
        <div className="feedback-panel">
          {this.renderTop(scores)}
          {this.renderSectionFeedbackSummary(scores)}
        </div>
      </div>
    )
  }
}
function mapStateToProps(state, ownProps) {
  return {
    isUKEnable: state.aspireFeedbackData.ukEnglish,
    user: state.user.data,
    ui: state.detailedFeedbackUi,
    processingStatus: state.aspireFeedbackData.status,
    visited_sections: state.aspireFeedbackData.visited_sections,
    feedback: state.aspireFeedbackData.data,
  }
}

export default connect(mapStateToProps, {
  showEditModal,
  changeProfilePicInitialEditState,
})(injectIntl(Overall))
